import AbstractDBService from './AbstractDBService'

const DB_VERSION = 4

class PassportDBService extends AbstractDBService {
  private static instance: PassportDBService

  onUpgrade (): void {
    // 버전 업데이트 시 로직 구현
  }

  public static getInstance () {
    if (!this.instance) {
      PassportDBService.instance = new PassportDBService('gtf-smart-db', 'encryptedPassport', DB_VERSION)
    }

    return PassportDBService.instance
  }
}

export default PassportDBService
